import { Component, Input } from "@angular/core";

import { PhmsCaseDocumentsComponent } from "@app/phms/documents/phms-case-documents.component";

@Component({
  selector: "phms-case-context-documents-tab",
  standalone: true,
  imports: [PhmsCaseDocumentsComponent],
  template: `
    <section class="case-context-tab case-context-tab--documents" aria-label="Documents">
      <phms-case-documents
        class="case-context-tab__panel"
        [incarceratedPersonId]="incarceratedPersonId"
      ></phms-case-documents>
    </section>
  `,
  styleUrl: "./case-context-tab-layout.scss",
})
export class CaseContextDocumentsTabComponent {
  @Input({ required: true }) incarceratedPersonId!: number;
}
